import { patchApiGalaxyServer } from 'services';

export interface ArchiveTeamPayload {
  teamId: number;
  customizedDataPreservationPeriod?: number;
  reasonToArchive: string;
}

export interface ArchiveTeamSuccessResponse {
  team_id: string;
}

export interface ArchiveTeamErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const archiveTeam = ({ params, token, config = {} }: BaseApiParams<ArchiveTeamPayload>) =>
  patchApiGalaxyServer(`/lookup/teams/archive`, params, config, token);
